import React, { useCallback, useContext, useState } from "react";
// import { ActionList, Button, LegacyCard as Card, Collapsible, Popover } from "@shopify/polaris";
import { Button, ButtonGroup, Popover, InlineStack, Text } from "@shopify/polaris";
import PropTypes from "prop-types";

// import context
import { PrivateContext } from "lib/context";

// config
// import constant from "lib/constant/constant";
import quickSettingConfig from "app/reports/provider/widgets/quickSetting/quickSettingConfig";
import { StyledActionCard, DropDown } from "app/reports/generic/style/quickAction";
import ProviderExportProduct from "app/productOld/modules/provider/features/exportProduct/export";
import { StyledView } from "asset/styles/globalStyle";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import quickAction from "./quickActionConfig";

const ProviderQuickAction = (props) => {
  const { link = [], storedata = [], linkView = [] } = props;
  const { cms, currentUser } = useContext(PrivateContext);
  const location = useLocation();
  const navigate = useNavigate();
  const { ecommercePlatform } = currentUser;
  const path = location.pathname;
  // const [actionLinkExpanded, setExpanded] = useState(false);
  const quickActionConfig = quickAction(cms);
  const { config, title } = quickSettingConfig(cms);
  const [popoverActive, setPopoverActive] = useState(false);
  const [popoverStoreActive, setPopoverStoreActive] = useState(false);
  const [isOpenModal, setModal] = useState(false);
  const actionCard = (action, secondary) => {
    const onAction = action.action || (() => navigate(action.link));
    return (
      <Button
        tone={action.primary ? "primary" : "tertiary"}
        variant={secondary ? "secondary" : "primary"}
        disabled={!!action.disabled}
        onClick={onAction}
        loading={action.loading}
      >
        {action.label}
      </Button>
    );
  };
  const actionCardView = (action) => {
    const onAction = action.action || (() => navigate(action.linkView));
    return (
      <>
        <Button
          tone={action.primary ? "primary" : "tertiary"}
          disabled={!!action.disabled}
          onClick={onAction}
          loading={action.loading}
        >
          {action.label}
        </Button>
      </>
    );
  };
  // eslint-disable-next-line no-shadow
  const togglePopoverActive = useCallback(() => setPopoverActive((popoverActive) => !popoverActive), []);
  const toggleStorePopoverActive = useCallback(
    // eslint-disable-next-line no-shadow
    () => setPopoverStoreActive((popoverStoreActive) => !popoverStoreActive),
    []
  );

  const activator = (
    <Button onClick={togglePopoverActive} disclosure>
      {title[path] || cms("common.actions.title.setting")}
    </Button>
  );

  const storeActivator = (
    <Button onClick={toggleStorePopoverActive} disclosure variant="secondary">
      {cms("common.button.storeSetting")}
    </Button>
  );
  const exportProductactivator = (
    <Button variant="primary" onClick={() => setModal(!isOpenModal)}>
      {cms("section.export.label.title")}
    </Button>
  );

  const getQuickActions = (actions = [], sec = false) => {
    if (!actions.length) return null;
    return <InlineStack gap="400">{actions.map((links) => actionCard(links, sec))}</InlineStack>;
  };

  const getOrderQuickActions = (actions = []) => {
    return <InlineStack gap="400">{actions.map((links) => actionCardView(links))}</InlineStack>;
  };

  const getQuickSettings = (settings = [], sec = false) => {
    // return settings.map((setting) => actionCard(setting));
    if (settings.length === 1) {
      return settings.map((setting) => <div>{actionCard(setting, sec)}</div>);
    }

    const options = settings.map((setting) => (
      <li>
        <Button variant="plain" onClick={() => navigate(setting.link)}>
          {setting.label}
        </Button>
      </li>
    ));

    return (
      <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive}>
        <DropDown className="drop-down">{options}</DropDown>
      </Popover>
    );
  };
  const getStoreQuickSettings = (storeData, sec = false) => {
    // return settings.map((setting) => actionCard(setting));
    if (storeData.length === 1) {
      return storeData.map((setting) => <div>{actionCard(setting, sec)}</div>);
    }

    const options = storeData.map((storeDataOptions) => (
      <li>
        <Button
          variant="plain"
          onClick={() => {
            // if (
            //   storeDataOptions.id === "importConnectProduct" ||
            //   storeDataOptions.id === "connectStoreProduct" ||
            //   storeDataOptions.id === "connectShop"
            // ) {
            //   navigate(storeDataOptions.link);
            // } else {
            //   storeDataOptions?.action();
            // }
            if (storeDataOptions?.action) {
              storeDataOptions?.action();
            } else if (storeDataOptions.link) {
              navigate(storeDataOptions.link);
            }
          }}
        >
          {storeDataOptions.label}
        </Button>
      </li>
    ));
    return (
      <Popover active={popoverStoreActive} activator={storeActivator} onClose={toggleStorePopoverActive}>
        <DropDown className="drop-down">{options}</DropDown>
      </Popover>
    );
  };
  const quickActions = (link.length && link) || quickActionConfig[path];
  const quickViewActions = (linkView.length && linkView) || quickActionConfig[path];
  const [firstElement, ...rest] = quickActions || [];

  const primaryViewActions = (quickViewActions || []).filter(
    (quickActionItem) => quickActionItem.primary || quickActionItem.caption
  );
  const primaryActions = (quickActions || []).filter((quickActionItem) => quickActionItem.primary);
  const secondaryActions = (quickActions || []).filter((quickActionItem) => !quickActionItem.primary);
  const pathNotForSecondaryActions = ["/products", "/product-lake"];

  return [
    <>
      {path === "/order-lake/view/:id" && (
        <StyledView>
          {primaryViewActions && primaryViewActions.length && (
            <Text as="span">{getOrderQuickActions(primaryViewActions)}</Text>
          )}
        </StyledView>
      )}
      <InlineStack align="space-between">
        <InlineStack gap="400">
          {primaryActions && primaryActions.length > 0 && <Text as="span">{getQuickActions(primaryActions)}</Text>}
          {config[path] && path === "/products" && <Text as="h5">{exportProductactivator}</Text>}
          <ProviderExportProduct openModal={isOpenModal} setOpenModal={setModal} />
        </InlineStack>
        <InlineStack gap="400">
          {secondaryActions && secondaryActions.length > 0 && !pathNotForSecondaryActions.includes(path) && (
            <Text as="span">{getQuickActions(secondaryActions, true)}</Text>
          )}
          {config[path] && path === "/products" && (
            <Text as="span">{getStoreQuickSettings((storedata.length !== 0 && storedata) || rest, true)}</Text>
          )}
          {config[path] && path === "/product-lake" && storedata.length && (
            <Text as="span">{getStoreQuickSettings((storedata.length !== 0 && storedata) || rest)}</Text>
          )}
          {!ecommercePlatform && config[path] && <Text as="span">{getQuickSettings(config[path], true)}</Text>}
        </InlineStack>
      </InlineStack>
      <br />
    </>,
  ];
};

ProviderQuickAction.propTypes = {
  link: PropTypes.arrayOf(PropTypes.object),
  storedata: PropTypes.arrayOf(PropTypes.object),
};

ProviderQuickAction.defaultProps = {
  link: [],
  storedata: [],
};

export default ProviderQuickAction;
